const features = [
  {
    name: "Toll Free Number",
    description:
      "Using a toll-free number, callers can get in touch with a business or organization without getting charged for long-distance fees. However, the business or organization that gets the call is the one responsible for the cost.",
    imageSrc: "https://www.knotnetworks.com/images/Toll-Free%20Number.jpg",
    imageAlt:
      "Stack of three green cardstock boxes with 3 hole cutouts showing cards inside.",
  },
  {
    name: "Inbound Call Centre",
    description:
      "An inbound call center is a company that provides help, support, or information when they get calls from clients or potential clients.",
    imageSrc:
      "https://www.knotnetworks.com/images/Inbound%20Call%20Centers%20Service%20&%20Solutions%20%20Knot%20Networks%20LLC.jpg",
    imageAlt: "Green cardstock box containing white, beige, and brown cards.",
  },
  {
    name: "Outbound Call Centre",
    description:
      "An outbound call center is a sales or marketing company that makes outgoing calls to clients or potential customers to promote products or services, find potential customers, or conduct surveys.",
    imageSrc:
      "https://www.knotnetworks.com/images/Driving%20Results%20Through%20Outbound%20Call%20Centers.jpg",
    imageAlt: "Green cardstock box open with 50 cards inside.",
  },

  {
    name: "International Toll Free Numbers",
    description:
      "An international toll-free number is a phone number that lets people from different countries call a company or organization without having to pay for long-distance charges. Instead, the company or organization that receives the call covers the cost.",
    imageSrc:
      "https://www.knotnetworks.com/images/International%20Toll%20free%20Numbers%20-%20Knot%20Networks%20LLC.jpg",
    imageAlt:
      "Stack of three green cardstock boxes with 3 hole cutouts showing cards inside.",
  },
  {
    name: "SIP Trunking",
    description:
      "SIP (Session Initiation Protocol) trunking is a method that lets businesses make and receive phone calls using the internet, eliminating the need for traditional phone lines and equipment.",
    imageSrc:
      "https://www.knotnetworks.com/images/Benefits%20Of%20Sip%20Trunking%20-%20Knot%20Networks%20LLC.jpg",
    imageAlt:
      "Stack of three green cardstock boxes with 3 hole cutouts showing cards inside.",
  },
];

export default function Example() {
  return (
    <div className="bg-white">
      <div className="mx-auto max-w-2xl px-4 py-10 sm:px-6 sm:py-30 lg:max-w-7xl lg:px-8">
        <div className="max-w-3xl">
          {/* <h2 id="features-heading" className="font-medium text-gray-500">
            Focus
          </h2> */}
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Simple productivity
          </p>
          <p className="mt-4 text-gray-500">
            Focus allows you to plan 10 daily tasks, while also thinking ahead
            about what's next. Forget distracting digital apps and embrace these
            small, sturdy pieces of paper.
          </p>
        </div>

        <div className="mt-11 grid grid-cols-1 items-start gap-x-6 gap-y-16 sm:mt-16 sm:grid-cols-2 lg:grid-cols-4 lg:gap-x-8">
          {features.map((feature) => (
            <div key={feature.name} className="flex flex-col-reverse">
              <div className="mt-6">
                <h3 className="text-sm font-medium text-gray-900">
                  {feature.name}
                </h3>
                <p className="mt-2 text-sm text-gray-500">
                  {feature.description}
                </p>
              </div>
              <img
                alt={feature.imageAlt}
                src={feature.imageSrc}
                className="aspect-square w-full rounded-lg bg-gray-100 object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
